/* DEMARE Warenkorb-Upsell: Kordel als "3. Kordel" in den Warenkorb legen (23.09., 15.10. Bundles)
   15.10.: Properties kommen aus data-dm-up-props (neuer Bundle-Block), sonst wie bisher.
   Im Drawer wird nur der Drawer neu gezeichnet (Minimog Cart-API), auf /cart neu geladen. */
(function () {
  /* 15.10.: wird auch global aus demare-header geladen (der Drawer kommt per fetch, Skripte darin laufen nicht) -> nur einmal binden */
  if (window.__dmUpBound) return;
  window.__dmUpBound = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dm-up-add]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-dm-up]');
    var note = box && box.querySelector('[data-dm-up-note]');
    var props = { 'Teil von Set': '3. Kordel', '_set_role': 'upsell' };
    if (b.dataset.dmUpProps) { try { props = JSON.parse(b.dataset.dmUpProps); } catch (x) {} }
    box.querySelectorAll('[data-dm-up-add]').forEach(function (x) { x.disabled = true; });
    if (note) { note.hidden = false; note.textContent = 'Wird hinzugefügt …'; }
    var inDrawer = !!b.closest('.scd__wrapper, .scd__content');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.dataset.dmUpAdd, 10), quantity: 1, properties: props }] })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        var C = window.MinimogTheme && window.MinimogTheme.Cart;
        if (inDrawer && C && C.refreshCart && C.renderNewCart) {
          return C.refreshCart().then(function () { return C.renderNewCart(); }).then(function () {
            try { if (C.updateCartCount) C.updateCartCount(C.cart); } catch (x) {}
            try { if (window.MinimogEvents) window.MinimogEvents.emit('ON_CART_UPDATE', C.cart); } catch (x) {}
          });
        }
        window.location.reload();
      })
      .catch(function () {
        if (inDrawer) { window.location.reload(); return; }
        box.querySelectorAll('[data-dm-up-add]').forEach(function (x) { x.disabled = false; });
        if (note) { note.hidden = false; note.textContent = 'Das hat nicht geklappt – bitte nochmal versuchen.'; }
      });
  });
})();
